import { render, staticRenderFns } from "./OnneAppFooter.vue?vue&type=template&id=0fd13b3b&scoped=true&"
import script from "./OnneAppFooter.vue?vue&type=script&lang=ts&"
export * from "./OnneAppFooter.vue?vue&type=script&lang=ts&"
import style0 from "./OnneAppFooter.vue?vue&type=style&index=0&id=0fd13b3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd13b3b",
  null
  
)

export default component.exports